// extracted by mini-css-extract-plugin
export default {"wrapper":"s_wrapper__vJXRE","img":"s_img__UGJ1v","btn":"s_btn__X0Jpi"};